export default [
    {   //费率维护
        path: "setting/finance",
        name: "settingtFinance",
        component: () => import(/* webpackChunkName: "setting" */ "@/views/setting/finance/index"),
    },

    // 产品管理
    {
        path: "products/allproducts/list",
        name: "allproductsList",
        component: () => import(/* webpackChunkName: "products" */ "@/views/products/allproducts/index"),
    },
    // 添加编辑
    {
        path: "products/allproducts/update/:type",
        name: "allproductsUpdate",
        component: () => import(/* webpackChunkName: "products" */ "@/views/products/allproducts/update"),
        // meta:{
        //     bread:false
        // }
    },

    // 分销产品管理
    {
        path: "products/distribution/list",
        name: "distributionList",
        component: () => import(/* webpackChunkName: "products" */ "@/views/products/distribution/index"),
    },

    // 编辑
    {
        path: "products/distribution/update/:type",
        name: "distributionUpdate",
        component: () => import(/* webpackChunkName: "products" */ "@/views/products/distribution/update"),
    },
    // 渠道产品管理
    {
        path: "products/channel/list",
        name: "prochannelList",
        component: () => import(/* webpackChunkName: "products" */ "@/views/products/channel/index"),
    },
    {
        path: "products/channel/admin/list",
        name: "prochannelAdminList",
        component: () => import(/* webpackChunkName: "products" */ "@/views/products/channel/admin/index"),
    },

    // 编辑、添加
    {
        path: "products/channel/update/:type",
        name: "prochannelUpdate",
        component: () => import(/* webpackChunkName: "products" */ "@/views/products/channel/update"),
        // meta:{
        //     bread:false
        // }
    },

    // 编辑、添加-管理
    {
        path: "products/channel/admin/update/:type",
        name: "prochannelUpdateAdmin",
        component: () => import(/* webpackChunkName: "products" */ "@/views/products/channel/admin/update"),
        // meta:{
        //     bread:false
        // }
    },

    // 渠道sfp产品管理
    {
        path: "products/sfp/list",
        name: "proSfpList",
        component: () => import(/* webpackChunkName: "products" */ "@/views/products/sfp/index"),
    },

    // 渠道sfp产品管理添加
    {
        path: "products/sfp/add",
        name: "proSfpAdd",
        component: () => import(/* webpackChunkName: "products" */ "@/views/products/sfp/add"),
        meta:{
            bread:false
        }
    },

    // 渠道sfp产品管理详情
    {
        path: "products/sfp/update/:type",
        name: "proSfpUpdate",
        component: () => import(/* webpackChunkName: "products" */ "@/views/products/sfp/update"),
        meta:{
            bread:false
        }
    },


    // 产品项目管理
    {
        path: "products/line/list",
            name: "productLineList",
        component: () => import(/* webpackChunkName: "products" */ "@/views/products/line/index"),
    },

    // 编辑、添加
    {
        path: "products/line/update/:type",
            name: "productLineUpdate",
        component: () => import(/* webpackChunkName: "products" */ "@/views/products/line/update"),
    },

    // 产品活动资源管理
    {
        path: "products/promotion/resource/list",
        name: "promotionResourceList",
        component: () => import(/* webpackChunkName: "products" */ "@/views/products/promotion/resource/index"),
    },
    // 产品活动资源编辑
    {
        path: "products/promotion/resource/update/:type",
        name: "promotionResourceUpdate",
        component: () => import(/* webpackChunkName: "products" */ "@/views/products/promotion/resource/update"),
    },

    // 产品活动资源管理
    {
        path: "products/promotion/list",
        name: "promotionList",
        component: () => import(/* webpackChunkName: "products" */ "@/views/products/promotion/index"),
    },
    {
        path: "products/promotion/report",
        name: "promotionReport",
        component: () => import(/* webpackChunkName: "products" */ "@/views/products/promotion/search"),
    },
    // 产品活动资源编辑
    {
        path: "products/promotion/update/:type",
        name: "promotionUpdate",
        component: () => import(/* webpackChunkName: "products" */ "@/views/products/promotion/update"),
    },

    // 活动流程管理
    {
        path: "products/activityProcess/list",
        name: "activityProcessList",
        component: () => import(/* webpackChunkName: "products" */ "@/views/products/activityProcess/index"),
    },
    // 活动流程管理编辑
    {
        path: "products/activityProcess/update/:type",
        name: "activityProcessUpdate",
        component: () => import(/* webpackChunkName: "products" */ "@/views/products/activityProcess/update"),
    },
    //活动流程管理列表
    {
        path: "products/activityProcess/management/list",
        name: "activityProcessManagementList",
        component: () => import(/* webpackChunkName: "products" */ "@/views/products/activityProcess/management/index"),
    },
    //活动流程管理审核
    {
        path: "products/activityProcess/audit/:type",
        name: "activityProcessAudit",
        component: () => import(/* webpackChunkName: "products" */ "@/views/products/activityProcess/management/audit"),
    },

    // 刷评资源管理
    {
        path: "products/brushreview/list",
        name: "brushReviewList",
        component: () => import(/* webpackChunkName: "products" */ "@/views/products/brushreview/index"),
    },
    {
        path: "products/brushreview/update/:type",
        name: "brushReviewUpdate",
        component: () => import(/* webpackChunkName: "products" */ "@/views/products/brushreview/update"),
    },
    // 仓库sku
    {
        path: "products/warehousesku/list",
        name: "warehouseskuList",
        component: () => import(/* webpackChunkName: "products" */ "@/views/products/warehouseSku/index"),
    },
    {
        path: "products/warehousesku/update/:type",
        name: "warehouseskuUpdate",
        component: () => import(/* webpackChunkName: "products" */ "@/views/products/warehouseSku/update"),
    },
    // 多规格产品补货
    {
        path: "products/replenish/index",
        name: "replenishList",
        component: () => import(/* webpckChunkName: "products" */ "@/views/products/replenish/index"),
    },
    // {
    //     path: "products/replenish/update/:type",
    //     name: "replenishUpdate",
    //     component: () => import(/* webpckChunkName: "products" */ "@/views/products/replenish/update"),
    // }

    // 测算上架
    {
        path: "products/calculationRelease/list",
        name: "calculationReleaseList",
        component: () => import(/* webpackChunkName: "products" */ "@/views/products/calculationRelease/index"),
    },
    // 测算上架编辑
    {
        path: "products/calculationRelease/update/:type",
        name: "calculationReleaseUpdate",
        component: () => import(/* webpackChunkName: "products" */ "@/views/products/calculationRelease/update"),
    },
    // 测算上架管理
    {
        path: "products/calculationRelease/admin/list",
        name: "calculationReleaseAdminList",
        component: () => import(/* webpackChunkName: "products" */ "@/views/products/calculationRelease/admin/index"),
    },
    // 测算上架管理编辑
    {
        path: "products/calculationRelease/admin/update/:type",
        name: "calculationReleaseAdminUpdate",
        component: () => import(/* webpackChunkName: "products" */ "@/views/products/calculationRelease/admin/update"),
    },
]
